<form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-content astral-sidebar-shell">
  <div class="form-body astral-sidebar-content astral-stack-l">
    <div class="astral-stack-m">
      <h2>{{ header | translate }}</h2>
      @if (infoText) {
        <app-information-block [text]="infoText | translate"></app-information-block>
      }
    </div>

    @if (showEsignatureLink) {
      <div>
        <astral-button variant="link-button" type="button" (click)="openEsignature($event)" labelKey="ESIGNATURE.OPEN_ERRAND"></astral-button>
      </div>
    }

    <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1">
      <astral-input [integerOnly]="true" [control]="form.controls['quantity']"></astral-input>
      <astral-input [integerOnly]="true" [control]="form.controls['remainingInKeyCabinet']"></astral-input>
      <astral-input [control]="form.controls['comment']"></astral-input>
    </astral-layout-group>
  </div>

  <div class="astral-sidebar-footer">
    <astral-button variant="primary" type="submit" [disabled]="submitButtonDisabled" labelKey="SAVE_BTN"></astral-button>
    <astral-button variant="secondary" type="button" (click)="onFormCancel()" labelKey="CANCEL_BTN"></astral-button>
    @if (!dataContext.create) {
      <astral-button
        variant="secondary"
        type="button"
        icon="trash"
        [disabled]="submitButtonDisabled"
        labelKey="DELETE_BTN"
        (click)="onFormDelete()"
      ></astral-button>
    }
  </div>
</form>
